import { Theme } from "@mui/material";
import { SystemStyleObject } from "@mui/system";

export const classes: Record<string, SystemStyleObject<Theme>> = {
  tag: {
    width: "40px",
    height: "40px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: ({ spacing }) => spacing(0.5),
    borderRadius: "100%",
  },
};
